import React from 'react';
import stylePreventivo from './PreventivoSideBar.module.scss';
import { useSelector,useDispatch } from 'react-redux';
import {Button} from 'antd';
import * as actionTypes from '../../redux/actions/actionTypes';

const Preventivo = (props) => {

    const datiPreventivo = useSelector(state => state.dataReducer.modello.datiPratica);
    const importo = applicaSeparatore(convertNumberFloat(datiPreventivo.importo));
    const tan = convertNumberFloat(datiPreventivo.tan);
    const taeg = convertNumberFloat(datiPreventivo.taeg);
    const rata = convertNumberFloat(datiPreventivo.rata);

    const dispatch = useDispatch();

    const backtoPreventivo = () => {
        dispatch({type: actionTypes.MODIFICA_PREVENTIVO, stepDiModifica: 0});
    }

    function convertNumberFloat(number){
        return ((number).toFixed(2)).replace('.',',');
    }

    function applicaSeparatore(importoNumerico){  
        var importo = importoNumerico.toString();  
        if(importo.length>3){  
          importo = importo.split('',importo.length).reverse().join('').replace(/([0-9]{3})/g,'$1.');  
          importo = importo.split('',importo.length).reverse().join('');  
        }  
        return importo;  
      } 


    return (
        <div className={stylePreventivo.Preventivo}>
            <h1 className={stylePreventivo.Titolo}>La soluzione che hai scelto</h1>
            <div className={stylePreventivo.contenuti}>

                <div className={stylePreventivo.singolaInfo}>
                    <h2 className={stylePreventivo.titoloInfo}>Importo</h2>
                    <p className={stylePreventivo.risultatoInfo}>{importo}€</p>
                </div>

                <div className={stylePreventivo.singolaInfo}>
                    <h2 className={stylePreventivo.titoloInfo}>Durata</h2>
                    <p className={stylePreventivo.risultatoInfo}>{datiPreventivo.numeroRate} mesi</p>
                </div>

                <div className={stylePreventivo.singolaInfo}>
                    <h2 className={stylePreventivo.titoloInfo}>Assicurazione</h2>
                    <p className={stylePreventivo.risultatoInfo}>
                        { datiPreventivo.assicurazione === true ? 'SI' : 'NO' }
                    </p>
                </div>

                <div className={stylePreventivo.singolaInfo}>
                    <h2 className={stylePreventivo.titoloInfo}>TAN</h2>
                    <p className={stylePreventivo.risultatoInfo}>{tan} %</p>
                </div>

                <div className={stylePreventivo.singolaInfo}>
                    <h2 className={stylePreventivo.titoloInfo}>TAEG</h2>
                    <p className={stylePreventivo.risultatoInfo}>{taeg} %</p>
                </div>

                <div className={stylePreventivo.singolaInfo}>
                    <h2 className={stylePreventivo.titoloInfo}>Rata</h2>
                    <p className={stylePreventivo.risultatoInfo}>{rata}€/mese</p>
                </div>
            </div>

            <Button className={stylePreventivo.backtoPreventivo} onClick={backtoPreventivo}>Modifica la tua scelta</Button>


        </div>
    )
}

export default Preventivo;